import MenuNames from "../../../constants/Menu/MenuNames.json";
import DlRcDetails from "../../../views/DlRcDetails";

const dlRcRoutes = [
  {
    menuName: MenuNames.DLRC_CHECK,
    path: "/dlrc-details",
    component: DlRcDetails,
    exact: true,
  },
  {
    menuName: MenuNames.DLRC_CHECK,
    path: "/dlrc-details/:Feid",
    component: DlRcDetails,
    exact: true,
  },
];

export default dlRcRoutes;
